export default {
  adserverRequestId: 'fake-adserver-request-id',
  htmlBeacons: [
    '<iframe id="multisync-iframe" height="0" width="0" marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//example.com" style="border: 0px; display: none;"></iframe>'
  ],
  cookieSyncUrls: ['//example.com', '//google.com'],
  creatives: [
    {
      auctionWinId: 'fake-auction-win-id',
      creative: {
        action: 'clickout',
        adm: '',
        advertiser: 'Pillsbury',
        beaconMetaData: {
          cpeBid: '900'
        },
        beacons: {
          click: ['https://sharethrough.com?test=trackclick'],
          impression: [],
          play: [],
          visible: [],
          'win-notification': []
        },
        brand_logo_url:
          'https://generic-creative-assets.s3.amazonaws.com/brand-logos/pillsbury.png',
        campaign_key: 'fake-campaign-key',
        creative_key: 'fake-creative-key',
        description:
          'Want to make just about the easiest waffles ever? These Cinnamon Roll Waffles with Cream Cheese Icing could not be any simpler... Or more delicious.',
        media_url:
          'https://www.pillsbury.com/everyday-eats/breakfast-brunch/cinnamon-roll-waffles-how-to',
        share_url:
          'https://www.pillsbury.com/everyday-eats/breakfast-brunch/cinnamon-roll-waffles-how-to',
        thumbnail_url:
          'https://generic-creative-assets.s3.amazonaws.com/nag/thumbnails/pillsbury-thumbnail.jpg',
        title: 'I am from header bidding',
        variant_key: 'fake-variant-key',
        clickout_same_page: false,
        slides: [],
        slideshow_autoscroll: false
      }
    }
  ],
  placement: {
    allowInstantPlay: true,
    articlesBeforeFirstAd: 2,
    articlesBetweenAds: 2,
    layout: 'multiple',
    metadata: {
      cardExperience: true,
      strOptOutIcon: true
    },
    placementAttributes: {
      allow_dynamic_cropping: true,
      customCardCss: 'body{background-color:#e6e6e6;}',
      dfp_path: '',
      enable_link_redirection: false,
      featured_content: [
        {
          creative: {
            action: 'clickout',
            advertiser: 'The Atlantic',
            creative_key: 'fake_featured_content_creative_key',
            description:
              'The Atlantic has been covering science - and covering it well - for some time now. But until today, we have hosted most of our science coverage here at TheAtlantic.com in our Technology and Health sections. From today on, Science will have its own section.',
            media_url:
              'https://www.theatlantic.com/science/archive/2015/09/introducing-the-atlantics-new-science-section/405088/',
            promoted_by_text: 'Gladly brought to you by: ',
            share_url:
              'https://www.theatlantic.com/science/archive/2015/09/introducing-the-atlantics-new-science-section/405088/',
            thumbnail_url:
              'https://cdn.theatlantic.com/assets/media/img/mt/2015/09/Earthrise2/lead_960.jpg?1442234751',
            title: "Introducing: The Atlantic's Science Section"
          }
        }
      ],
      promoted_by_text: 'Ad by',
      strOptOutIcon: true,
      strOptOutUrl:
        'https://platform-cdn.sharethrough.com/privacy-policy?language=EN',
      template:
        '&lt;div class=&quot;str-adunit str-card-exp str-adunit-img-left str-{{#isi.text}}isi str-{{action}}{{/isi.text}}{{^isi.text}}{{action}}{{/isi.text}}&quot;&gt;\n      &lt;div class=&quot;str-thumbnail&quot;&gt;&lt;/div&gt;\n      &lt;div class=&quot;str-flex&quot;&gt;\n        &lt;div class=&quot;str-text&quot;&gt;\n          &lt;div class=&quot;str-title&quot;&gt;{{title}}&lt;/div&gt;\n          &lt;div class=&quot;str-description&quot;&gt;{{description}}&lt;/div&gt;\n        &lt;/div&gt;\n        &lt;div class=&quot;str-bottom&quot;&gt;\n          &lt;div class=&quot;str-advertiser&quot;&gt;{{promoted_by_text}} {{advertiser}}\n            &lt;div class=&quot;str-brand-logo&quot; style=&quot;background-image:url(&#39;{{brand_logo_url}}&#39;);&quot;&gt;&lt;/div&gt;\n          &lt;/div&gt;\n          &lt;div class=&quot;str-cta&quot;&gt;See More&lt;/div&gt;\n        &lt;/div&gt;\n      &lt;/div&gt;&lt;style&gt;.str-adunit-img-left{box-sizing:border-box;width:100%;max-width:728px;margin:auto;font-family:sans-serif;font-size:16px;line-height:16px;color:black;background-color:white;display:flex;flex-direction:row;overflow:hidden;border:1px solid #eee;}.str-adunit-img-left .str-title,.str-adunit-img-left .str-description,.str-adunit-img-left .str-advertiser{text-align:left;}.str-adunit-img-left .str-thumbnail,.str-adunit-img-left .thumbnail-wrapper{order:1;flex-shrink:0;flex-grow:1;max-width:350px !important;background-color:#EBF0F0;}.str-adunit-img-left .thumbnail-wrapper{width:40% !important;height:auto !important;}.str-adunit-img-left .str-thumbnail{background-size:cover;background-position:50%;background-repeat:no-repeat;width:100%;padding-bottom:56.25%;}.str-adunit-img-left .str-flex{order:2;padding:8px 0 8px 10px;flex-grow:1;flex-shrink:2;display:flex;flex-direction:column;justify-content:center;}.str-adunit-img-left .str-text{order:2;flex-grow:1;display:flex;flex-direction:column;justify-content:space-evenly;}.str-adunit-img-left .str-title{padding-right:15px;font-weight:bold;order:1;}.str-adunit-img-left .str-description{padding-right:8px;font-size:12px;order:2;}.str-adunit-img-left .str-bottom{padding-right:8px;order:2;flex-grow:0;flex-shrink:0;display:flex;justify-content:space-between;font-size:12px;vertical-align:middle;}.str-adunit-img-left .str-brand-logo{display:inline-block;width:16px;height:16px;max-width:16px;max-height:16px;background-size:cover;background-position:50%;background-repeat:no-repeat;vertical-align:middle;border:none;background-color:inherit;margin-left:8px;}.str-adunit-img-left .str-advertiser{line-height:30px;}.str-adunit-img-left .str-cta{background-color:#596777;color:white;border-radius:5px;height:30px;padding:0 23px;line-height:30px;flex-shrink:0;}.str-adunit-img-left:hover .str-cta{background-color:#4BD1A6;}.str-adunit-img-left .str-opt-out-container{bottom:100% !important;bottom:unset !important;top:0 !important;order:2;border-radius:0 0 0 8px !important;}.str-adunit-img-left.str-isi{padding-bottom:105px !important;}.str-adunit-img-left .str-isi-bundle{border-top:1px solid #eee;padding:2px;bottom:0;line-height:initial;}.str-adunit-img-left .str-isi-headline{border-bottom:1px solid #eee;font-size:90% !important}.str-adunit-img-left.str-banner .thumbnail-wrapper{height:197px !important;}@media (max-width:768px){.str-adunit-img-left{flex-direction:column;width:300px;}/*.str-adunit-img-left.str-banner .thumbnail-wrapper,.str-adunit-img-left.str-banner .str-thumbnail{height:auto !important;}*/.str-adunit-img-left .str-flex{padding:8px;}.str-adunit-img-left .str-description{display:none;}.str-adunit-img-left .str-title{padding:0 0 8px 0;}.str-adunit-img-left .str-bottom *{height:20px;line-height:20px;}.str-adunit-img-left .str-bottom{padding:0;}.str-adunit-img-left .str-cta{padding:0 12px;}.str-adunit-img-left .str-thumbnail,.str-adunit-img-left .thumbnail-wrapper,.str-adunit-img-left.str-banner .thumbnail-wrapper{width:300px !important;height:169px !important;padding-bottom:0;}}&lt;/style&gt;&lt;/div&gt;',
      template_key: 'fake-template-key',
      third_party_partners: [
        {
          key: 'stxnetwork',
          tag:
            '&lt;i class=&apos;use-iframe&apos; data-width=&apos;100%&apos; data-height=&apos;200&apos; data-url=&apos;//placement-networks.sharethrough.com/f37048e2/tag&apos;&gt;'
        },
        {
          key: '785ff21e',
          tag:
            '&lt;i class=&apos;use-iframe&apos; data-width=&apos;700&apos; data-height=&apos;200&apos; data-url=&apos;//placement-networks.sharethrough.com/fa2e028a/tag&apos;&gt;'
        },
        {
          key: '7860afa7',
          tag:
            '&lt;i class=&apos;use-iframe&apos; data-width=&apos;300&apos; data-height=&apos;200&apos; data-url=&apos;//placement-networks.sharethrough.com/919ff672/tag&apos;&gt;'
        }
      ]
    },
    status: 'live'
  }
};
